<template lang="html">
  <v-page>
    <nav class="topbar fixed-top navbar" :class="'topbar-' + profile">
      <v-container><v-logo white/></v-container>
    </nav>
    <v-breadcrumb :steps="[{ label: 'FAQ - Perguntas Mais Frequentes' }]" />
    <v-container class="mt-4">
      <v-row>
        <v-col :xs="12" :sm="12" :md="12" :lg="3">
          <v-tabs class="flex-column nav-pills">
            <v-button href="#tab-general" class="active"
              >Perguntas gerais</v-button
            >
            <v-button href="#tab-find-professionals"
              >Encontrar profissionais</v-button
            >
            <v-button href="#tab-contract">Contratação</v-button>
            <v-button href="#tab-credits">Compra de créditos</v-button>
            <v-button href="#tab-professional">Perfil do Profissional</v-button>
            <v-button href="#tab-search">Tela Buscar</v-button>
            <v-button href="#tab-request"
              >Tela Requisitar profissionais</v-button
            >
            <v-button href="#tab-monitor">Tela de Acompanhamento</v-button>
            <v-button href="#tab-wallet">Tela Carteira</v-button>
            <v-button href="#tab-profile-client"
              >Tela Perfil Contratante</v-button
            >
            <v-button href="#tab-professionals">Tela Profissionais</v-button>
          </v-tabs>
        </v-col>
        <v-col :xs="12" :sm="12" :md="12" :lg="9">
          <div class="tab-content">
            <v-content
              class="tab-pane fade active show"
              id="tab-general"
              role="tabpanel"
            >
              <div id="faq-accordion-general">
                <v-accordion
                  id="faq-general-1"
                  group="faq-accordion-general"
                  title="O que é a Vibbra?"
                >
                  A Vibbra é uma plataforma que seleciona profissionais da área
                  de software de alto nível e ajuda as empresas a contratá-los,
                  intermediando essa relação, principalmente para o modelo de
                  trabalho remoto.
                </v-accordion>
                <v-accordion
                  id="faq-general-2"
                  group="faq-accordion-general"
                  title="Quais os perfis de profissionais que a Vibbra seleciona?"
                >
                  Atualmente selecionamos profissionais de desenvolvimento de
                  software, gestão de projetos de software, análise de negócios
                  e de design.
                </v-accordion>
                <v-accordion
                  id="faq-general-3"
                  group="faq-accordion-general"
                  title="Por que a Vibbra atua somente com esses perfis e não outros, ou de outras áreas?"
                >
                  Como somos uma plataforma de profissionais selecionados, faz
                  parte do nosso processo de seleção testar na prática os
                  conhecimentos técnicos de cada candidato. Para isso,
                  desenvolvemos testes específicos de cada conhecimento, logo,
                  não temos na nossa plataforma profissionais para os quais
                  ainda não temos testes práticos para aplicar. Já sobre
                  profissionais de outras áreas como marketing, atualmente nossa
                  plataforma está focada em TI, desenvolvimento de software.
                </v-accordion>
                <v-accordion
                  id="faq-general-4"
                  group="faq-accordion-general"
                  title="O que é a intermediação que a Vibbra se propõe em fazer?"
                >
                  Na Vibbra você pode buscar, contratar, pagar e fazer o
                  gerenciamento das liberações dos pagamentos de acordo com as
                  atividades entregues pelos profissionais. Ou seja, realizamos
                  toda a intermediação de cada uma dessa etapas, minimizando
                  riscos, agilizando processos e trazendo mais segurança para a
                  relação Contratante x Profissional.
                </v-accordion>
                <v-accordion
                  id="faq-general-5"
                  group="faq-accordion-general"
                  title="A Vibbra é responsável pela gestão do profissional que eu contrato pela Plataforma?"
                >
                  A Vibbra como Plataforma se destina unicamente na
                  intermediação da relação Contratante e Profissional, logo, a
                  gestão das atividades de um profissional contratado na
                  Plataforma, é sempre de responsabilidade do Contratante. Para
                  mais informações, veja nossos
                  <v-link :to="{ name: 'terms' }" target="_blank"
                    ><b>Termos de Uso</b></v-link
                  >.
                </v-accordion>
                <v-accordion
                  id="faq-general-6"
                  group="faq-accordion-general"
                  title="Posso entender que a Vibbra é uma fábrica de software/software house?"
                >
                  Não. A Vibbra é uma Plataforma que intermedia a relação entre
                  Contratante e Profissional, a fim de facilitar processos. Ou
                  seja, não se trata de uma empresa que se responsabiliza pela
                  execução de projetos de software como é o caso de fábricas de
                  software. Os profissionais que compõem a equipe da empresa
                  Vibbra, atuam unicamente em atividades referentes a Plataforma
                  Vibbra e não em projetos ou contratos de empresas Contratantes
                  da Plataforma.
                </v-accordion>
                <v-accordion
                  id="faq-general-7"
                  group="faq-accordion-general"
                  title="O que é um(a) Vibbrante?"
                >
                  O Vibbrante é o profissional que foi aprovado no nosso
                  processo de seleção completo. Ou seja, que além de ter o
                  perfil ideal para performar no trabalho remoto, nós
                  comprovamos na prática seus conhecimentos com nossos testes
                  técnicos e entrevistas. Apenas 7 em cada 100 candidatos passam
                  por todo o processo e se tornam Vibbrantes.
                </v-accordion>
                <v-accordion
                  id="faq-general-8"
                  group="faq-accordion-general"
                  title="O que é um(a) Talent Vibbra?"
                >
                  Na Vibbra os perfis chamados de Talent são profissionais
                  semi-selecionado, que passaram na etapa de análise de perfil,
                  mas não temos a comprovação de conhecimentos com testes
                  técnicos e entrevistas.
                </v-accordion>
                <v-accordion
                  id="faq-general-9"
                  group="faq-accordion-general"
                  title="Para que posso contratar os profissionais da Vibbra (Talents e Vibbrantes)?"
                >
                  Bom, o céu é limite! Mas vamos dar algumas sugestões de
                  trabalhos para os quais vemos nossos clientes contratando os
                  profissionais da nossa rede.
                  <br /><br />
                  <ul class="list-group">
                    <li class="list-group-item">
                      Fazer um site institucional novo.
                    </li>
                    <li class="list-group-item">
                      Fazer um aplicativo mobile ou um sistema web do zero.
                    </li>
                    <li class="list-group-item">
                      Dar suporte a um ou mais websites que já existem.
                    </li>
                    <li class="list-group-item">
                      Dar continuidade a um projeto de software já existente.
                    </li>
                    <li class="list-group-item">
                      Ajudar a tirar seu negócio do papel, planejamento o
                      projeto com um analista de negócio.
                    </li>
                    <li class="list-group-item">Auditoria de software.</li>
                    <li class="list-group-item">
                      Aulas e treinamentos técnicos com algum dos profissionais
                      de nível sênior, de várias linguagens que dominam.
                    </li>
                    <li class="list-group-item">Gerir um time de software.</li>
                    <li class="list-group-item">Implantação de sistemas.</li>
                    <li class="list-group-item">
                      Criar um layout de site/app com um designer de UI.
                    </li>
                    <li class="list-group-item">
                      Fazer ou melhorar a usabilidade e interação do seu
                      site/app/sistema com um designer de UI/UX.
                    </li>
                    <li class="list-group-item">
                      Posicionar ou reposicionar seu negócio com um designer de
                      Branding.
                    </li>
                  </ul>
                  <br />
                  De qualquer forma, você sempre pode solicitar a ajuda da nossa
                  equipe para encontrar o profissional certo para o que você
                  precisa.
                </v-accordion>
                <v-accordion
                  id="faq-general-10"
                  group="faq-accordion-general"
                  title="Se eu quiser, posso contratar o processo de seleção da Vibbra?"
                >
                  Sim, você pode! Devido a abordagem de algumas empresas de RH,
                  resolvemos empacotar nosso processo de seleção em um produto a
                  parte da Plataforma Vibbra. Ou seja, você pode contratar a
                  aplicação do nosso processo para uma lista de candidatos que
                  tiver. Para mais informações, acesse esse
                  <v-link
                    href="http://vibbra.com.br/keynotes/vibbra-selecao.pdf"
                    target="_blank"
                    >link</v-link
                  >.
                </v-accordion>
                <v-accordion
                  id="faq-general-11"
                  group="faq-accordion-general"
                  title="Eu preciso pagar algo pelo uso da Plataforma?"
                >
                  Não! O acesso a Plataforma Vibbra é totalmente gratuita para
                  Contratantes e Profissionais. Os Contratantes apenas pagam
                  pela compra de créditos referentes a horas de trabalho dos
                  profissionais que contratam.
                </v-accordion>
                <v-accordion
                  id="faq-general-12"
                  group="faq-accordion-general"
                  title="Além do valor hora do profissional que é mostrado em seu perfil, eu pago mais algum valor pra Vibbra ao contratá-lo?"
                >
                  O valor da hora de cada profissional já inclui a comissão da
                  Vibbra referente aos serviços da Plataforma e de
                  intermediação. Ou seja, nenhuma taxa adicional é cobrada.
                </v-accordion>
              </div>
            </v-content>
            <v-content
              class="tab-pane fade"
              id="tab-find-professionals"
              role="tabpanel"
            >
              <div id="faq-accordion-find-professionals">
                <v-accordion
                  id="faq-find-prof-1"
                  group="faq-accordion-find-professionals"
                  title="Como acho o profissional que desejo na Plataforma?"
                >
                  Você deve acessar a tela de Busca, no menu Profissionais >
                  Buscar. Em seguida, digite no campo de busca geral, a tag da
                  tecnologia ou o conhecimento que você deseja do profissional
                  procurado, por exemplo, JAVA. Em seguida clique em Filtrar que
                  então serão listados todos os profissionais que possuem essa
                  tag vinculada ao seu perfil em nossa Plataforma. Você também
                  pode usar os demais filtros da busca, que você pode conhecer
                  melhor nas FAQs listadas no item "Tela Buscar" ao lado.
                </v-accordion>
                <v-accordion
                  id="faq-find-prof-2"
                  group="faq-accordion-find-professionals"
                  title="Após encontrar o profissional na tela de Busca, como faço pra falar com ele?"
                >
                  Para abrir um canal de comunicação com um profissional,
                  primeiro você precisa requisitá-lo na Plataforma. Para isso,
                  na tela de busca, clique no botão "Selecionar", que aparece na
                  card de cada profissional que você deseja. Ao selecionar, eles
                  irão aparecer na barra de Selecionados na esquerda da tela,
                  juntamente com o botão "Avançar". Ao clicar em Avançar, você
                  irá para a tela de Requisição e então deve preencher algumas
                  informações sobre sua demanda para requisitá-los. Para mais
                  informações veja as FAQs listadas no item "Tela Requisitar
                  profissionais" ao lado.
                </v-accordion>
                <v-accordion
                  id="faq-find-prof-3"
                  group="faq-accordion-find-professionals"
                  title="Posso entrevistar/fazer reuniões com os profissionais?"
                >
                  Sim, mas apenas após assinar o contrato e comprar créditos
                  referentes a pelo menos 1h do profissional. Fazemos isso para
                  que Contratante e Profissional estejam cobertos pelas
                  cláusulas do nosso contrato, principalmente no que se refere
                  ao sigilo das informações que serão trocadas por fora de nossa
                  plataforma. Além disso, é necessário evitarmos que pessoas má
                  intencionadas contratem nossos profissionais por fora da nossa
                  plataforma, uma vez que essa ação desrespeita nossos
                  <v-link :to="{ name: 'terms' }" target="_blank"
                    ><b>Termos de Uso</b></v-link
                  >. Por fim, como trabalhamos somente com profissionais de alto
                  nível, o tempo deles precisa ser valorizado e nada mais justo
                  que recebem por cada hora trabalhada, mesmo que sendo em
                  reuniões.
                </v-accordion>
                <v-accordion
                  id="faq-find-prof-4"
                  group="faq-accordion-find-professionals"
                  title="Posso entrevistar/fazer reuniões com os profissionais, antes de contratar?"
                >
                  Não, conforme explicado na pergunta acima. Caso você precise
                  de ajuda, não deixe de entrar em contato com a nossa equipe.
                </v-accordion>
                <v-accordion
                  id="faq-find-prof-5"
                  group="faq-accordion-find-professionals"
                  title="Quando requisito um profissional já estou contratando ele?"
                >
                  Não. Requisitar um ou mais profissionais, nada mais é do abrir
                  pedidos de contratação, ou seja, você está sinalizando que tem
                  interesse naquele profissional e apresenta informações da sua
                  demanda. A contratação de fato só acontece após a assinatura
                  do contrato e a compra dos primeiros créditos por
                  profissional.
                </v-accordion>
                <v-accordion
                  id="faq-find-prof-6"
                  group="faq-accordion-find-professionals"
                  title="Se não sei quantas horas quero contratar, como devo proceder?"
                >
                  Você pode pedir para o próprio profissional estimar um escopo
                  de atividades que tenha, enviando materiais para ele como
                  links públicos de ferramentas como Google Drive ou Dropbox, na
                  descrição da sua demanda, na tela de Requisição. Lembre-se de
                  que pra estimar, o profissional precisa de um escopo claro e
                  bem detalhado. Ou ainda, você pode usar o botão "Ajuda da
                  Vibbra pra estimar" da tela de Requisição, que nossa equipe
                  comercial entrará em contato para orientá-lo quanto a isso.
                </v-accordion>
                <v-accordion
                  id="faq-find-prof-7"
                  group="faq-accordion-find-professionals"
                  title="Posso pedir estimativas para o profissional?"
                >
                  Sim, conforme descrito na pergunta acima.
                </v-accordion>
                <v-accordion
                  id="faq-find-prof-8"
                  group="faq-accordion-find-professionals"
                  title="Se não tenho um escopo detalhado do meu projeto, a Vibbra pode me ajudar com isso?"
                >
                  Sim! Você pode contratar uma consultoria da própria Vibbra
                  para ajudá-lo com a definição de um escopo para o seu projeto,
                  ou contratar um de nossos Analistas de Negócio que são
                  especialistas nesse tipo de trabalho. No caso da consultoria
                  da Vibbra, entre em contato pelo email
                  <b>quero@vibbra.com.br</b> solicitando esse serviço. No caso
                  do Analista de Negócio, você pode filtrar na busca pela tag
                  ANALISTA DE NEGÓCIO e requisitar um profissional por cerca de
                  5h, descrevendo que deseja ajuda com detalhamento de escopo e
                  estimativa. 5h é apenas uma sugestão, mas que pode ser
                  suficiente pra essa tarefa, dependendo da complexidade e
                  tamanho do seu projeto.
                </v-accordion>
                <v-accordion
                  id="faq-find-prof-9"
                  group="faq-accordion-find-professionals"
                  title="Quando requisito um profissional, preciso detalhar todo o meu projeto do campo Descrição?"
                >
                  Não. Apenas informe uma breve descrição para que o
                  profissional entenda do que se trata a sua demanda e consiga
                  avaliar se consegue ou não atendê-la técnicamente.
                  Detalhamento completo de escopo pode ficar para a primeira
                  reunião entre vocês, logo após a contratação.
                </v-accordion>
                <v-accordion
                  id="faq-find-prof-10"
                  group="faq-accordion-find-professionals"
                  title="Posso selecionar vários profissionais e requisitar todos pra depois escolher?"
                >
                  Sim, mas sem exageros. Não há problema em requisitar mais de
                  um profissional para a mesma demanda, para que possa
                  esclarecer melhor suas dúvidas com cada um antes de decidir.
                  Porém, foque em requisitar profissionais do mesmo perfil. Ou
                  seja, evite selecionar todo tipo de profissional, de qualquer
                  perfil, como designers, gestores e desenvolvedores, para uma
                  demanda que se trata de programação de um site em WordPress.
                  Nesse caso, foque em profissionais que sejam do perfil
                  Desenvolvedor Front-end Web e dominem a tecnologia WordPress.
                </v-accordion>
                <v-accordion
                  id="faq-find-prof-11"
                  group="faq-accordion-find-professionals"
                  title="Como tiro dúvidas com o profissional que quero?"
                >
                  Após requisitá-los, você será direcionado para a tela
                  Profissionais > Em contratação. Nela, cada profissional terá o
                  botão de "Mensagens" na sua card. Nesse botão você poderá
                  trocar mensagens com ele pela nossa plataforma. Para mais
                  informações veja as FAQs listadas no item "Tela Profissionais"
                  ao lado.
                </v-accordion>
                <v-accordion
                  id="faq-find-prof-12"
                  group="faq-accordion-find-professionals"
                  title="Posso montar um time completo de profissionais aqui na Vibbra?"
                >
                  Com certeza! Na nossa Plataforma você pode contratar tanto um
                  profissional específico, quanto uma equipe completa para
                  delegar um projeto inteiro a ela. Você pode contratar um
                  Analista de Negócios para planejar o seu projeto, um Designer
                  e um Desenvolvedor, para tirar ele do papel e um Gestor para
                  liderar essa equipe técnica e lhe apresentar relatórios
                  periódicos do progresso, sem que você se preocupe com nada.
                  Caso precise de ajuda com isso, entre em contato com nossa
                  equipe através do email <b>quero@vibbra.com.br</b>.
                </v-accordion>
              </div>
            </v-content>
            <v-content class="tab-pane fade" id="tab-contract" role="tabpanel">
              <div id="faq-accordion-contract">
                <v-accordion
                  id="faq-contract-1"
                  group="faq-accordion-contract"
                  title="Como funciona a contratação?"
                >
                  A contratação de um profissional pela Plataforma Vibbra
                  envolve basicamente 2 etapas: assinatura de contrato e compra
                  de créditos. Tanto o Profissional quanto o Contratante
                  precisam assinar o contrato para formalizar uma contratação.
                  Após isso, é necessário o Contratante efetuar a primeira
                  compra de créditos para que o Profissional contratado se torne
                  ativo e tenha autorização para iniciar os trabalhos.
                </v-accordion>
                <v-accordion
                  id="faq-contract-2"
                  group="faq-accordion-contract"
                  title="Após a contratação, tenho acesso direto ao profissional?"
                >
                  Sim! Após termos o contrato assinado e a primeira compra de
                  créditos, o Contratante tem acesso direto ao Profissional e
                  pode atuar com ele como se fosse parte de sua equipe, porém de
                  forma remota. A partir desse momento, a Vibbra segue apenas
                  monitorando o progresso dos trabalhos para garantir que tudo
                  está fluindo bem, além de seguir ajudando na intermediação dos
                  pagamentos e no apoio quanto a relação estabelecida.
                </v-accordion>
                <v-accordion
                  id="faq-contract-3"
                  group="faq-accordion-contract"
                  title="Posso contratar o profissional diretamente, sem ser pela Plataforma Vibbra?"
                >
                  Não e sim! Não, pois uma abordagem direta de um profissional
                  da nossa plataforma, para contratação externa, desrespeita
                  nossos
                  <v-link :to="{ name: 'terms' }" target="_blank"
                    ><b>Termos de Uso</b></v-link
                  >
                  e pode gerar consequências como multas e questões legais.
                  Porém, se há o interesse de uma contratação direta por ambas
                  as partes, a Vibbra apenas cobre uma taxa referente a
                  liberação do profissional, como uma espécie de taxa de hunter,
                  uma vez que essa contratação só irá ocorrer graças ao trabalho
                  de seleção a aproximação feita pela Plataforma. Para mais
                  informações entre em contato pelo email
                  <b>quero@vibbra.com.br</b>.
                </v-accordion>
                <v-accordion
                  id="faq-contract-4"
                  group="faq-accordion-contract"
                  title="Posso contratar profissionais CLT pela Plataforma Vibbra?"
                >
                  Essencialmente não. Porém, você pode usar a nossa plataforma
                  para prospectar profissionais e então entrar em contato com a
                  nossa equipe, sinalizando o interesse de realizar uma proposta
                  CLT a um dos profissionais. Nesses casos, havendo interesse de
                  ambas as partes, a Vibbra libera o profissional cobrando uma
                  taxa de hunter. Para mais informações entre em contato pelo
                  email <b>quero@vibbra.com.br</b>.
                </v-accordion>
                <v-accordion
                  id="faq-contract-5"
                  group="faq-accordion-contract"
                  title="Posso contratar profissionais por projetos ou apenas por horas?"
                >
                  A base dos contratos pela Plataforma Vibbra são sobre volumes
                  de horas. Porém, havendo a necessidade de ser um contrato por
                  escopo fechado, entre em contato com a nossa equipe pelo email
                  <b>quero@vibbra.com.br</b>, que podemos avaliar o caso e
                  viabilizar um segundo contrato a parte da Plataforma.
                </v-accordion>
                <v-accordion
                  id="faq-contract-6"
                  group="faq-accordion-contract"
                  title="Meu contrato é com a Vibbra ou direto com o profissional?"
                >
                  Após a assinatura do contrato e a compra de créditos, seu
                  contato será direto com o profissional. Antes disso, seu
                  contato com o profissional deve ser exclusivamente pela
                  Plataforma e será mediado por nossa equipe.
                </v-accordion>
                <v-accordion
                  id="faq-contract-7"
                  group="faq-accordion-contract"
                  title="Qual a diferença do contrato para a contratação de Talents Vibbra e de Vibbrantes?"
                >
                  Os Vibbrantes são profissionais onde temos um nível elevado de
                  confiança, uma vez que testamos seus conhecimentos e o
                  entrevistamos, por isso, para eles a Vibbra intermedia o
                  contrato. Ao contratar um Vibbrante, na verdade o Contratante
                  está contratando o CNPJ da Vibbra e a Vibbra contrata o
                  Profissional. Já para o caso de Talents Vibbra, o contrato
                  ocorre diretamente entre Contratante e Profissional, tendo a
                  Vibbra apenas como parte intermediadora.
                </v-accordion>
                <v-accordion
                  id="faq-contract-8"
                  group="faq-accordion-contract"
                  title="O que o contrato da Vibbra cobre?"
                >
                  Principalmente questões de sigilo, confidencialidade,
                  propriedade intelectual, responsabilidade das partes, perfil
                  contratado e escopo de horas.
                </v-accordion>
                <v-accordion
                  id="faq-contract-9"
                  group="faq-accordion-contract"
                  title="Posso aplicar um contrato específico que a minha empresa usa ao invés do contrato da Plataforma da Vibbra?"
                >
                  Em todos os casos de contratação na Plataforma Vibbra, o nosso
                  contrato padrão deverá ser assinado na Plataforma pelas
                  partes. Porém, para casos específicos onde a empresa
                  Contratante possui a necessidade da aplicação de um contrato
                  próprio, nossa equipe deve ser contatada para que possamos
                  analisar o caso junto ao nosso jurídico.
                </v-accordion>
                <v-accordion
                  id="faq-contract-10"
                  group="faq-accordion-contract"
                  title="Posso assinar além do contrato da Plataforma Vibbra, um outro contrato diretamente com o profissional que escolhi?"
                >
                  Não, pois isso seria classificado como contratação direta do
                  Profissional por fora da Plataforma, o que desrespeita nossos
                  <v-link :to="{ name: 'terms' }" target="_blank"
                    ><b>Termos de Uso</b></v-link
                  >. Havendo qualquer tipo de necessidade nesse sentido, nossa
                  equipe deve ser procurada para avaliar o caso.
                </v-accordion>
              </div>
            </v-content>
            <v-content class="tab-pane fade" id="tab-credits" role="tabpanel">
              <div id="faq-accordion-credits">
                <v-accordion
                  id="faq-credits-1"
                  group="faq-accordion-credits"
                  title="O que são os Créditos na Plataforma?"
                >
                  Os créditos são os valores pagos pelo Contratante referente a
                  quantidade de horas que deseja liberar para um Profissional
                  trabalhar. Ou seja, 1 crédito se refere a 1h de um dado
                  Profissional. Vamos a um exemplo. Se o valor hora do
                  profissional é R$ 80,00 e você quer liberar ele para trabalhar
                  por 10 horas, precisa comprar 10 créditos dele, que referem-se
                  a 10h x R$ 80,00, logo, R$ 800,00. Cada Profissional tem o seu
                  valor hora, então, 10 créditos de um Profissional A pode
                  custar um valor diferente do que 10 créditos de um
                  Profissional B.
                </v-accordion>
                <v-accordion
                  id="faq-credits-2"
                  group="faq-accordion-credits"
                  title="Posso colocar uma carga de créditos na Plataforma e usar com qualquer Profissional?"
                >
                  Nesse momento, ainda não, pois você faz carga de créditos por
                  Profissional e não de forma global. Atuamos dessa forma pois
                  cada profissional tem o seu valor de hora, então, créditos por
                  Profissional faz mais sentido. Porém, já estamos considerando
                  uma evolução da Plataforma para também operar com créditos
                  globais.
                </v-accordion>
                <v-accordion
                  id="faq-credits-3"
                  group="faq-accordion-credits"
                  title="Como faço o pagamento?"
                >
                  Assim que você solicita a compra de créditos para um ou mais
                  profissionais na sua Carteira, nossa equipe financeira recebe
                  o seu pedido e irá processá-lo. Em breve, você receberá em seu
                  email a nota fiscal referente ao valor total dos créditos
                  solicitados, bem como os dados bancários da nossa empresa para
                  a realização de uma transferência. Atualmente estamos operando
                  apenas com transferências bancárias como TED e DOC, mas em
                  breve, iremos disponibilizar também o pagamento por boletos.
                  Após confirmarmos o seu pagamento, os créditos são liberados
                  na Plataforma.
                </v-accordion>
                <v-accordion
                  id="faq-credits-4"
                  group="faq-accordion-credits"
                  title="Como o pagamento é recebido pelo profissional?"
                >
                  Todo Profissional contratado precisa obrigatoriamente reportar
                  na Plataforma cada atividade trabalhada, bem como a quantidade
                  de horas e minutos utilizados na sua execução. Apenas após o
                  Contratante revisar essas atividades reportadas e aprová-las
                  na Plataforma, é que liberamos o valor referente a quantidade
                  de horas trabalhadas na conta do Profissional como créditos
                  para saque. O Profissional então solicita o resgate desses
                  créditos pela Plataforma. Para mais informações sobre esse
                  relatório de horas trabalhadas, veja as FAQs listadas no item
                  "Tela Acompanhamento" ao lado.
                </v-accordion>
                <v-accordion
                  id="faq-credits-5"
                  group="faq-accordion-credits"
                  title="Em caso de cancelar o contrato de um profissional, já tendo créditos comprados, o que acontece?"
                >
                  Nesses casos você pode seguir com uma das opções abaixo.
                  <br /><br />
                  <ul class="list-group">
                    <li class="list-group-item">
                      Solicitar a nossa equipe a transferência desses créditos
                      para outro Profissional que deseja contratar ou já esteja
                      utilizando.
                    </li>
                    <li class="list-group-item">
                      Deixar os créditos na Plataforma para utilizá-los
                      futuramente em uma nova demanda. Seus créditos apenas
                      expiram após 6 meses da data de compra.
                    </li>
                    <li class="list-group-item">
                      Solicitar o resgate do valor pago. Nesse caso, temos um
                      prazo de 30 dias para processar a operação.
                    </li>
                  </ul>
                </v-accordion>
                <v-accordion
                  id="faq-credits-6"
                  group="faq-accordion-credits"
                  title="Posso transferir créditos de um profissional para outro?"
                >
                  Sim! A única questão nesse caso é que provavelmente o valor da
                  hora de cada profissional pode ser diferente, então, o valor
                  disponível irá considerar o valor hora do novo profissional.
                  Vamos a um exemplo. Digamos que você contratou 10h de um
                  Profissional A que tem o valor de hora em R$ 100,00,
                  totalizando R$ 1.000,00 em créditos. Após o cancelamento do
                  contrato com esse profissional, você terá esses R$ 1.000,00 em
                  créditos na Plataforma para utilizar com um outro
                  Profissional. Digamos que o Profissional B que você está
                  contratando, tenha um valor de hora de R$ 50,00. Nesse caso,
                  os R$ 1.000,00 que você possui de créditos, darão direito a 20
                  horas do Profissional B.
                </v-accordion>
                <v-accordion
                  id="faq-credits-7"
                  group="faq-accordion-credits"
                  title="Posso resgatar meus créditos?"
                >
                  A Vibbra efetua a devolutiva de créditos comprados e não
                  utilizados na plataforma, mediante pedido formalizado junto ao
                  nosso tive de Customer Success (CS), havendo a retenção de 40%
                  do valor solicitado, referente à utilização da plataforma e
                  processos administrativos e fiscais. O prazo para
                  processamento desta operação pela equipe Vibbra é de 30 dias
                  corridos.
                </v-accordion>
                <v-accordion
                  id="faq-credits-8"
                  group="faq-accordion-credits"
                  title="Existe o risco de eu perder os créditos que comprei na Plataforma?"
                >
                  Os créditos expiram após 6 meses da data de sua compra, ou
                  seja, caso você compre créditos para um profissional e não
                  utilize ele pelo prazo de 6 meses, eles expiram e você terá de
                  comprá-los novamente.
                </v-accordion>
                <v-accordion
                  id="faq-credits-9"
                  group="faq-accordion-credits"
                  title="Se não ter créditos comprados, consigo seguir o trabalho com o profissional?"
                >
                  Não. Usamos bastante a analogia de um tanque de gasolina em um
                  carro. Havendo gasolina, você consegue andar com o carro,
                  senão, precisa abastecer. Na Plataforma Vibbra ocorre a mesma
                  dinâmica com os Profissionais. Sendo assim, se os créditos
                  para um Profissional se esgotam, ele não consegue mais
                  reportar atividades na Plataforma e não terá garantias de
                  recebimento se seguir trabalhando sem créditos. Então, é
                  necessário sempre seguir comprando créditos para utilizar os
                  serviços dos Profissionais pelo tempo desejado.
                </v-accordion>
              </div>
            </v-content>
            <v-content
              class="tab-pane fade"
              id="tab-professional"
              role="tabpanel"
            >
              <div id="faq-accordion-professional">
                <v-accordion
                  id="faq-professional-1"
                  group="faq-accordion-professional"
                  title="O que significa a tag vibbrante! ou a tag talent que aparece no canto superior esquerdo do perfil do profissional?"
                >
                  Na Plataforma Vibbra temos 2 tipos de Profissionais:
                  Vibbrantes e Talents Vibbra. Explicamos a diferença de
                  ambos nas FAQs "Perguntas gerais". Essa tag sinaliza o tipo
                  desse Profissional.
                </v-accordion>
                <v-accordion
                  id="faq-professional-2"
                  group="faq-accordion-professional"
                  title="O que significa o V com uma nota do lado (exemplo: V 8,5), que aparece no canto superior direito do perfil do Profissional?"
                >
                  Refere-se a nota desse Profissional no processo de seleção da
                  Vibbra. Essa informação aparece apenas para os Profissionais
                  Vibbrantes, pois somente eles passaram pelo nosso processo
                  completo de seleção.
                </v-accordion>
                <v-accordion
                  id="faq-professional-3"
                  group="faq-accordion-professional"
                  title="O que significam as informações logo abaixo do nome do Profissional?"
                >
                  Essas informações referem-se ao Perfil e ao Foco de atuação do
                  profissional. Por exemplo, Perfil: Designer, Foco de atuação:
                  Branding.
                </v-accordion>
                <v-accordion
                  id="faq-professional-4"
                  group="faq-accordion-professional"
                  title="O que significa o link do perfil público no perfil do Profissional?"
                >
                  Esse link abre uma tela com o mesmo perfil do Profissional,
                  porém, com algumas informações ocultas, para que possa ser
                  compartilhado publicamente, por fora da Plataforma Vibbra. Use
                  esse link para o caso de apresentar um Profissional específico
                  para pessoas da sua equipe que não possuem conta de usuário na
                  Plataforma.
                </v-accordion>
                <v-accordion
                  id="faq-professional-5"
                  group="faq-accordion-professional"
                  title="Qual a diferença do Perfil interno do Profissional na Plataforma e do seu Perfil Público?"
                >
                  O perfil interno do Profissional traz todas as informações
                  referentes a ele que coletamos na Plataforma, além de detalhes
                  da nossa avaliação no processo de seleção que aplicamos e
                  feedbacks dos clientes que já o contrataram. O perfil público
                  foca em apresentar uma prévia do Profissional, com alguns
                  informações pontuais apenas e é acessível publicamente, por
                  fora da Plataforma, sem a necessidade de estar logado.
                </v-accordion>
                <v-accordion
                  id="faq-professional-6"
                  group="faq-accordion-professional"
                  title="Porque no Perfil Público do Profissional nem todas as suas informações aparecem?"
                >
                  Por questões relacionadas a nossa Política de Privacidade,
                  apenas determinadas informações podem ser divulgadas
                  publicamente. As demais informações, podem ser acessíveis
                  apenas por usuários da Plataforma Vibbra.
                </v-accordion>
                <v-accordion
                  id="faq-professional-7"
                  group="faq-accordion-professional"
                  title="Posso compartilhar o link do perfil público do Profissional com outras pessoas que não possuem cadastro na Plataforma Vibbra?"
                >
                  Sim! Foi exatamente para isso que criamos essa versão pública
                  do perfil do Profissional.
                </v-accordion>
                <v-accordion
                  id="faq-professional-8"
                  group="faq-accordion-professional"
                  title="O que significa o item Experiência no perfil do Profissional?"
                >
                  Refere-se ao total de anos de experiência de mercado desse
                  Profissional.
                </v-accordion>
                <v-accordion
                  id="faq-professional-9"
                  group="faq-accordion-professional"
                  title="O que significa o item Valor/hora no perfil do Profissional?"
                >
                  Refere-se ao valor cobrado por hora desse Profissional. Esse
                  valor já inclui o comissionamento da Plataforma Vibbra.
                </v-accordion>
                <v-accordion
                  id="faq-professional-10"
                  group="faq-accordion-professional"
                  title="O que significa o item Horas semanais livres no perfil do Profissional?"
                >
                  Refere-se a quantidade de horas que o Profissional possui
                  disponível para demandas da Plataforma Vibbra.
                </v-accordion>
                <v-accordion
                  id="faq-professional-11"
                  group="faq-accordion-professional"
                  title="O que significa o item Horário comercial no perfil do Profissional?"
                >
                  Refere-se a disponibilidade do Profissional em atuar durante
                  horário comercial.
                </v-accordion>
                <v-accordion
                  id="faq-professional-12"
                  group="faq-accordion-professional"
                  title="O que significa o item Inglês no perfil do Profissional?"
                >
                  Refere-se ao nível de domínio da língua inglesa pelo
                  Profissional.
                </v-accordion>
                <v-accordion
                  id="faq-professional-13"
                  group="faq-accordion-professional"
                  title="O que significa o item Clientes estrangeiros no perfil do Profissional?"
                >
                  Refere-se ao Profissional ja ter tido ou não experiência com
                  clientes de fora do Brasil.
                </v-accordion>
                <v-accordion
                  id="faq-professional-14"
                  group="faq-accordion-professional"
                  title="O que significa o item Cidade no perfil do Profissional?"
                >
                  Refere-se a Cidade onde o Profissional reside atualmente.
                </v-accordion>
                <v-accordion
                  id="faq-professional-15"
                  group="faq-accordion-professional"
                  title="O que significa o item Idade no perfil do Profissional?"
                >
                  Refere-se a idade do Profissional.
                </v-accordion>
                <v-accordion
                  id="faq-professional-16"
                  group="faq-accordion-professional"
                  title="O que significa o item Código do profissional no perfil do Profissional?"
                >
                  Refere-se ao identificador único do Profissional na Plataforma
                  Vibbra.
                </v-accordion>
                <v-accordion
                  id="faq-professional-17"
                  group="faq-accordion-professional"
                  title="O que é a aba Sobre no perfil do Profissional?"
                >
                  Refere-se a uma breve apresentação escrita pelo próprio
                  Profissional.
                </v-accordion>
                <v-accordion
                  id="faq-professional-18"
                  group="faq-accordion-professional"
                  title="O que é a aba Habilidades no perfil do profissional?"
                >
                  Refere-se a lista de habilidades e conhecimentos que o
                  Profissional domina, com uma barra de % que representa o grau
                  desse domínio. Quanto mais próximo de 100%, mais o
                  Profissional domina aquela habilidade específica.
                </v-accordion>
                <v-accordion
                  id="faq-professional-19"
                  group="faq-accordion-professional"
                  title="O que é a aba Avaliação Vibbra no perfil do profissional?"
                >
                  Detalhamento do resultado do processo de seleção da Vibbra com
                  esse Profissional. Essa aba é exibida apenas para Vibbrantes.
                </v-accordion>
                <v-accordion
                  id="faq-professional-20"
                  group="faq-accordion-professional"
                  title="O que é a aba Feedbacks de Clientes no perfil do profissional?"
                >
                  Refere-se a lista de avaliações por parte dos clientes que
                  contrataram o Profissional em questão.
                </v-accordion>
              </div>
            </v-content>
            <v-content class="tab-pane fade" id="tab-search" role="tabpanel">
              <div id="faq-accordion-search">
                <v-accordion
                  id="faq-search-1"
                  group="faq-accordion-search"
                  title="O que é a tela Buscar?"
                >
                  Tela onde você encontra todos os Profissionais selecionados da
                  Plataforma Vibbra. Nela você pode aplicar filtros para
                  encontrar profissionais específicos, além de ver detalhes do
                  perfil de cada um. Pode também selecionar e avançar para
                  requisitá-los para suas demandas.
                </v-accordion>
                <v-accordion
                  id="faq-search-2"
                  group="faq-accordion-search"
                  title="O que é o campo Busca geral por tags?"
                >
                  É onde você pode aplicar tags para buscar profissionais
                  específicos. Conforme você digita, as tags relacionadas serão
                  listadas com a função de auto completar. As tags podem ser de
                  linguagens de programação, como por exemplo, JAVA, JAVASCRIPT,
                  PYTHON, RUBY, PHP, etc, como também de habilidades ou perfis,
                  como DESENVOLVEDOR, DESIGNER, SCRUM, GESTÃO DE PROJETOS, etc.
                  Caso você comece a digitar algo e nenhuma tag apareça para
                  seleção, significa que nenhum profissional vinculou a tag que
                  você está buscando ao seu perfil. Nesses casos, tente uma tag
                  mais ampla e genérica, ou variações da palavra que você busca.
                  Caso você não consiga encontrar o profissional desejado, não
                  deixe de entrar em contato com nossa equipe, pois podemos lhe
                  ajudar de diferentes maneiras.
                </v-accordion>
                <v-accordion
                  id="faq-search-3"
                  group="faq-accordion-search"
                  title="O que é o filtro Valor da hora?"
                >
                  É o filtro que deve ser aplicado caso queira limitar sua busca
                  a uma determinada faixa de valor de hora dos Profissionais.
                </v-accordion>
                <v-accordion
                  id="faq-search-4"
                  group="faq-accordion-search"
                  title="O que faz o botão Opções avançadas?"
                >
                  Ao clicar nesse botão, você terá acesso a mais filtros para
                  que possa refinar ainda mais a sua busca.
                </v-accordion>
                <v-accordion
                  id="faq-search-5"
                  group="faq-accordion-search"
                  title="O que é o campo Perfil desejado?"
                >
                  Refere-se ao perfil do Profissional, considerando os 5 perfis
                  que disponibilizamos na Plataforma Vibbra, que são:
                  ANALISTA/GESTOR, ANALISTA DE NEGÓCIO, GESTOR DE PROJETOS,
                  DESIGNER e DESENVOLVEDOR. Ao selecionar um dos perfis dessa
                  lista, o campo "Foco de atuação" irá carregar automaticamente
                  somente os focos relacionados ao perfil que você selecionou.
                </v-accordion>
                <v-accordion
                  id="faq-search-6"
                  group="faq-accordion-search"
                  title="O que é o campo Foco de atuação?"
                >
                  Dentro de cada perfil, pode haver um ou mais focos de atuação,
                  que se referem a uma especialização do Profissional em uma
                  determinada área de conhecimento. Por exemplo, um Profissional
                  do perfil DESIGNER, pode ter seu foco de atuação em BRANDING,
                  o que significa que ele como designer pode realizar diferentes
                  trabalhos, mas é em branding que ele tem um foco maior e mais
                  experiência. Esse campo inicia em branco, pois depende que
                  seja escolhido um perfil no campo "Perfil desejado" para então
                  mostrar suas opções.
                </v-accordion>
                <v-accordion
                  id="faq-search-7"
                  group="faq-accordion-search"
                  title="O que é o campo Código do profissional?"
                >
                  Refere-se ao código que um Profissional na Plataforma Vibbra,
                  ou seja, é o identificador único do Profissional. Esse campo
                  deve ser usado caso você queira encontrar um Profissional em
                  específico, procurando ele pelo seu código. Você pode ver o
                  código de cada Profissional na tela do seu Perfil completo. Em
                  alguns casos, onde a nossa equipe comercial realiza
                  indicações, você receberá os códigos dos Profissionais e deve
                  aplicar nesse campo para encontrá-los.
                </v-accordion>
                <v-accordion
                  id="faq-search-8"
                  group="faq-accordion-search"
                  title="O que é o campo Habilidades específicas?"
                >
                  Campo onde você pode pesquisar por uma habilidade específica
                  que esteja procurando. Aqui se encaixam habilidades,
                  conhecimentos, itens técnicos, comportamentais, etc. Por
                  exemplo: REACT, JS, MYSQL, ADOBE PHOTOSHOP, PMI, BITCOIN,
                  COMUNICAÇÃO, etc.
                </v-accordion>
                <v-accordion
                  id="faq-search-9"
                  group="faq-accordion-search"
                  title="O que é o campo Tipo de profissional?"
                >
                  Na Plataforma Vibbra temos 2 tipos de Profissionais:
                  Vibbrantes e Talents Vibbra. Explicamos a diferença de
                  ambos nas FAQs "Perguntas gerais". Ao selecionar um deles,
                  serão listados apenas Profissionais do tipo escolhido.
                </v-accordion>
                <v-accordion
                  id="faq-search-10"
                  group="faq-accordion-search"
                  title="O que é o filtro Horas disponíveis por semana?"
                >
                  Cada Profissional informa em seu perfil, quantas horas ele
                  consegue disponibilizar para projetos através da Plataforma
                  Vibbra. Você pode então utilizar esse filtro para encontrar
                  Profissionais que tenham a disponibilidade de tempo certa para
                  a sua demanda. Porém, é importante destacarmos que muitas
                  vezes essa informação pode estar desatualizada, então,
                  sugerimos que mesmo não tendo a disponibilidade desejada, você
                  entre em contato com o Profissional e confirme essa informação
                  com ele.
                </v-accordion>
                <v-accordion
                  id="faq-search-11"
                  group="faq-accordion-search"
                  title="O que é o filtro Experiência?"
                >
                  Filtro utilizado para você encontrar somente profissionais que
                  tenham a experiência de mercado que você precisa dele. Você
                  pode considerar uma margem considerando anos de experiência.
                </v-accordion>
                <v-accordion
                  id="faq-search-12"
                  group="faq-accordion-search"
                  title="O que faz o botão Limpar tudo?"
                >
                  Apenas remove a aplicação de todos os filtros que você possa
                  ter escolhido e retorna os mesmos para suas posições iniciais.
                  Se você clicar em Limpar tudo e depois em Filtrar, irá listar
                  todos os profissionais da Plataforma sem a aplicação de
                  filtros, da mesma forma que ocorre logo que você acessa a tela
                  de Busca.
                </v-accordion>
                <v-accordion
                  id="faq-search-13"
                  group="faq-accordion-search"
                  title="O que faz o botão Filtrar?"
                >
                  Dispara a ação de busca, aplicando os filtros selecionados e
                  lista os Profissionais encontrados.
                </v-accordion>
                <v-accordion
                  id="faq-search-14"
                  group="faq-accordion-search"
                  title="O que são as tags abaixo de Horas semanais livres na card de cada profissional?"
                >
                  São as 5 principais habilidades de conhecimento que aquele
                  Profissional vinculou ao seu perfil.
                </v-accordion>
                <v-accordion
                  id="faq-search-15"
                  group="faq-accordion-search"
                  title="O que faz o botão Selecionar no final da card de cada profissional?"
                >
                  Ao clicar nesse botão, o Profissional em questão irá aparecer
                  na lista de Selecionados, ao lado esquerdo da tela.
                </v-accordion>
                <v-accordion
                  id="faq-search-16"
                  group="faq-accordion-search"
                  title="O que são os profissional que aparecem na box Selecionados, no lado esquerdo da tela?"
                >
                  Esses devem ser os profissionais que você tem interesse em
                  entrar em contato.
                </v-accordion>
                <v-accordion
                  id="faq-search-17"
                  group="faq-accordion-search"
                  title="O que faz o botão Avançar na box de Selecionados?"
                >
                  Ao clicar, você irá para a tela de requisição dos
                  profissionais levando apenas aqueles que estão como
                  Selecionados.
                </v-accordion>
              </div>
            </v-content>
            <v-content class="tab-pane fade" id="tab-request" role="tabpanel">
              <div id="faq-accordion-request">
                <v-accordion
                  id="faq-request-1"
                  group="faq-accordion-request"
                  title="O que é a tela Requisitar profissionais?"
                >
                  Tela onde você informa quantas horas deseja de cada
                  profissional selecionado na tela de Busca, além de uma breve
                  descrição do que espera que eles façam. O objetivo aqui é
                  apresentar a sua demanda aos profissionais e abrir um canal de
                  comunicação para esclarecimento de dúvidas. Requisitar não é
                  contratar.
                </v-accordion>
                <v-accordion
                  id="faq-request-2"
                  group="faq-accordion-request"
                  title="O que é o campo Previsão de horas que deseja contratar na card de cada profissional?"
                >
                  Refere-se a sua previsão de quantas horas pretende utilizar de
                  cada profissional. Se trata de uma estimativa da sua parte,
                  não se preocupe em ser exato ou preciso. Essa informação serve
                  basicamente para que o Profissional entenda o tamanho da sua
                  demanda ou por quanto tempo você pretende aloca-lo.
                </v-accordion>
                <v-accordion
                  id="faq-request-3"
                  group="faq-accordion-request"
                  title="O que faz o botão Ajuda da Vibbra pra estimar na card de cada Profissional?"
                >
                  Caso você não saiba informar a quantidade de horas que deseja
                  do Profissional, ou caso você tenha um escopo de atividades e
                  gostaria de ajuda para ter uma estimativa, você pode clicar
                  nesse botão e entrar em contato com a nossa equipe. Porém,
                  você mesmo pode informar ao Profissional que deseja uma
                  estimativa de horas, porém, pra isso, será necessário que
                  repasse mais informações do seu escopo para que consiga
                  estimar. Você pode fazer isso através de um documento
                  compartilhado e público em ferramentas como Drive e Dropbox,
                  incluído na descrição da sua demanda.
                </v-accordion>
                <v-accordion
                  id="faq-request-4"
                  group="faq-accordion-request"
                  title="O que é o campo Breve descrição do que você espera do talent na card de cada Profissional?"
                >
                  Se trata de uma breve descrição das atividades que você espera
                  que o profissional execute. Não se trata de um escopo
                  detalhado, mas sim uma introdução da sua demanda, para que o
                  Profissional tome conhecimento do que se trata e consiga
                  avaliar se consegue ou não ajudá-lo. Aproveite esse campo para
                  também já esclarecer eventuais dúvidas que possam ter, como
                  confirmar algum conhecimento técnico ou experiência
                  necessária, confirmar a disponibilidade de horas do
                  profissional, etc.
                </v-accordion>
                <v-accordion
                  id="faq-request-5"
                  group="faq-accordion-request"
                  title="O que faz o botão Requisitar no final da tela?"
                >
                  Ao clicar, você está disparado aos Profissionais a notificação
                  do seu interesse em contratá-los, mas isso ainda não se trata
                  da efetivação do contrato. Após requisitá-los, você poderá
                  trocar mensagens com eles pela Plataforma.
                </v-accordion>
              </div>
            </v-content>
            <v-content class="tab-pane fade" id="tab-monitor" role="tabpanel">
              <div id="faq-accordion-monitor">
                <v-accordion
                  id="faq-monitor-1"
                  group="faq-accordion-monitor"
                  title="O que é a tela de Acompanhamento?"
                >
                  Tela onde você acompanha em detalhes o trabalho que está sendo
                  executado por um determinado Profissional contratado. Nela
                  você tem acesso aos dados de contato do Profissional em
                  questão, um painel de controle quanto ao consumo das horas
                  contratadas e o relatórios de atividades x horas executadas
                  pelo Profissional. É nessa tela também que você aprova horas
                  trabalhadas para que o profissional possa receber.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-2"
                  group="faq-accordion-monitor"
                  title="O que significa o item Status, na box esquerda da tela?"
                >
                  Refere-se ao status do contrato com esse Profissional. Os
                  status são: Ativo, para contratos que estão abertos;
                  Finalizado, para contratos que já foram encerrados.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-3"
                  group="faq-accordion-monitor"
                  title="O que significa o item Valor/hora do contrato, na box esquerda da tela?"
                >
                  Refere-se ao valor da hora aplicado a esse contrato
                  específico. Por padrão, o valor hora aplicado é sempre o mesmo
                  mostrado no perfil do Profissional. Porém, em casos onde
                  ocorrem negociações exclusivas, esse valor pode sofrer
                  alteração apenas para o contrato em questão.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-4"
                  group="faq-accordion-monitor"
                  title="O que significa o item E-mail, na box esquerda da tela?"
                >
                  Refere-se ao email do Profissional contratado.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-5"
                  group="faq-accordion-monitor"
                  title="O que significa o item Celular, na box esquerda da tela?"
                >
                  Refere-se ao telefone celular/WhatsApp do Profissional
                  contratado.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-6"
                  group="faq-accordion-monitor"
                  title="O que significa o item Skype, na box esquerda da tela?"
                >
                  Refere-se ao usuário no Skype do Profissional contratado.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-7"
                  group="faq-accordion-monitor"
                  title="O que significa o item Hangouts, na box esquerda da tela?"
                >
                  Refere-se ao usuário no Hangouts do Profissional contratado.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-8"
                  group="faq-accordion-monitor"
                  title="O que significa o item Data de início, na box esquerda da tela?"
                >
                  Refere-se a data de início prevista para esse contrato. Por
                  padrão, a data de início é sempre 24h após a assinatura do
                  contrato pelo Contratante.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-9"
                  group="faq-accordion-monitor"
                  title="O que significa o item Previsão de conclusão, na box esquerda da tela?"
                >
                  Refere-se a previsão/estimativa da data de conclusão do
                  contrato. Essa data é calculada com base no volume de horas
                  contratadas e na disponibilidade de horas semanais do
                  Profissional.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-10"
                  group="faq-accordion-monitor"
                  title="O que faz o botão Contratar mais horas?"
                >
                  Ao clicar, abre um popup para que você possa contratar mais
                  horas para esse Profissional específico, sem ter que acessar a
                  sua carteira. Você pode contratar mais horas sempre que quiser
                  ou achar necessário. Lembre-se de que precisam haver horas
                  contratadas e pagas na Plataforma para que o Profissional seja
                  autorizado a trabalhar no seu contrato.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-11"
                  group="faq-accordion-monitor"
                  title="O que faz o botão Ver contrato?"
                >
                  Ao clicar, você será levado a tela do contrato assinado para
                  esse Profissional. É a mesma tela que você acessou durante o
                  processo de contratação.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-12"
                  group="faq-accordion-monitor"
                  title="O que faz o botão Finalizar contrato?"
                >
                  Caso o trabalho com o Profissional tenha concluído e você não
                  possui previsão de novas demandas a curto prazo, você pode
                  solicitar a finalização do contrato por esse botão. Nossa
                  equipe receberá o seu pedido e irá processá-lo. Após a
                  finalização, você poderá avaliar o Profissional em questão.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-13"
                  group="faq-accordion-monitor"
                  title="O que significam as horas contratadas?"
                >
                  Referem-se ao total de horas do contrato desse Profissional,
                  ou seja, a quantidade de horas que você solicitou a assinar o
                  contrato, somadas as horas que foram adicionadas depois meio
                  de aditivos.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-14"
                  group="faq-accordion-monitor"
                  title="O que significam as horas liberadas?"
                >
                  Referem-se ao total de horas que foram compradas através dos
                  créditos na Plataforma para esse Profissional. Elas estão como
                  "liberadas" para sinalizar ao Profissional que já foram pagas
                  e que ele está liberado para trabalhar por essa quantidade de
                  horas.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-15"
                  group="faq-accordion-monitor"
                  title="O que significam as horas pendentes?"
                >
                  Referem-se ao total de horas que já foram pagas e ainda não
                  foram trabalhadas. É o saldo total de horas das liberadas que
                  o Profissional ainda tem em aberto para cumprir.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-16"
                  group="faq-accordion-monitor"
                  title="O que significam as horas trabalhadas?"
                >
                  Referem-se ao total de horas que já foram trabalhadas pelo
                  Profissional e reportadas na Plataforma.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-17"
                  group="faq-accordion-monitor"
                  title="O que é o Acompanhamento de horas?"
                >
                  Parte da tela onde você encontra o relatório de horas
                  trabalhadas pelo Profissional, para que consiga realizar o
                  acompanhamento das atividades e as horas gastas em cada uma.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-18"
                  group="faq-accordion-monitor"
                  title="O que é uma Sprint?"
                >
                  Sprint é como chamamos um ciclo de 15 dias corridos na
                  Plataforma Vibbra. Assim que um contrato se torna Ativo, a
                  Sprint 1 é aberta e se encerrará em 15 dias. Assim que uma
                  Sprint se encerra, uma nova se abre automaticamente para mais
                  15 dias. Esse processo segue sequencialmente até que o
                  contrato seja finalizado.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-19"
                  group="faq-accordion-monitor"
                  title="O que são as atividades reportadas em uma Sprint?"
                >
                  Referem-se às atividades que o Profissional reportou dentro de
                  um determinado ciclo de 15 dias, a chamada Sprint.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-20"
                  group="faq-accordion-monitor"
                  title="Quando devo aprovar as horas trabalhadas em uma Sprint?"
                >
                  Sempre que uma Sprint se encerra, irá aparecer nessa tela de
                  Acompanhamento, o botão para aprovação das atividades x horas
                  reportadas pelo Profissional nessa Sprint. Esse é o momento
                  onde você como Contratante, precisa revisar as horas
                  reportadas para confirmar que está tudo certo e então aprovar
                  as mesmas. Assim que você aprova, o valor referente as horas
                  trabalhadas será repassado ao Profissional.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-21"
                  group="faq-accordion-monitor"
                  title="O que acontece quando aprovo uma Sprint?"
                >
                  Assim que você aprova uma Sprint, significa que você confirma
                  que aquelas atividades foram executadas e que podemos efetuar
                  o pagamento ao Profissional, referente ao total de horas
                  reportadas na Sprint.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-22"
                  group="faq-accordion-monitor"
                  title="O faz o link Solicitar revisão de horas?"
                >
                  Caso você não concorde com a quantidade de horas reportadas
                  pelo Profissional para uma determinada atividade, você pode
                  solicitar a revisão de horas. Esse pedido é sinalizado ao
                  Profissional que então entrará em contato com você para
                  explicar o motivo das horas. Em caso de não haver resolução
                  entre as partes, a Vibbra intervêm para resolver a questão.
                  Como resultado, uma atividade que teve solicitação de revisão
                  de horas, pode se manter a mesma, pode ser removida, ou pode
                  sofrer alteração para um volume de horas diferente, dependendo
                  a resolução atingida.
                </v-accordion>
                <v-accordion
                  id="faq-monitor-23"
                  group="faq-accordion-monitor"
                  title="Quando devo solicitar revisão de horas?"
                >
                  Apenas quando você de fato acredita que a quantidade de horas
                  reportada está incoerente com a atividade desempenhada. Para
                  isso, é importante você ter conhecimento técnico ou solicitar
                  apoio de um profissional de tecnologia de sua equipe, para que
                  consiga avaliar com clareza se há ou não algo a se questionar.
                </v-accordion>
              </div>
            </v-content>
            <v-content class="tab-pane fade" id="tab-wallet" role="tabpanel">
              <div id="faq-accordion-wallet">
                <v-accordion
                  id="faq-wallet-1"
                  group="faq-accordion-wallet"
                  title="O que é a tela Carteira?"
                >
                  Refere-se a sua carteira na Plataforma Vibbra. É onde você
                  compra créditos, acompanha os pagamentos feitos aos Vibbrantes
                  e pode verificar o extrato financeiro de suas operações na
                  Plataforma.
                </v-accordion>
                <v-accordion
                  id="faq-wallet-2"
                  group="faq-accordion-wallet"
                  title="O que são os Créditos?"
                >
                  Os créditos são os valores pagos pelo Contratante referente a
                  quantidade de horas que deseja liberar para um Profissional
                  trabalhar. Ou seja, 1 crédito se refere a 1h de um dado
                  Profissional. Vamos a um exemplo. Se o valor hora do
                  profissional é R$ 80,00 e você quer liberar ele para trabalhar
                  por 10 horas, precisa comprar 10 créditos dele, que referem-se
                  a 10h x R$ 80,00, logo, R$ 800,00. Cada Profissional tem o seu
                  valor hora, então, 10 créditos de um Profissional A pode
                  custar um valor diferente do que 10 créditos de um
                  Profissional B.
                </v-accordion>
                <v-accordion
                  id="faq-wallet-3"
                  group="faq-accordion-wallet"
                  title="O que faz o botão Comprar Créditos?"
                >
                  Ao clicar, abre um popup listando todos os Profissionais que
                  você tem contratado na Plataforma, para que possa informar
                  quantas horas deseja contratar de cada um. As horas de cada
                  profissional serão multiplicadas por seus respectivos valores
                  de hora e então você verá o total de créditos que deve comprar
                  para liberar essas horas.
                </v-accordion>
                <v-accordion
                  id="faq-wallet-4"
                  group="faq-accordion-wallet"
                  title="Após solicitar a compra de créditos, o que acontece?"
                >
                  Assim que você solicita a compra de créditos para um ou mais
                  profissionais na sua Carteira, nossa equipe financeira recebe
                  o seu pedido e irá processá-lo. Em breve, você receberá em seu
                  email a nota fiscal referente ao valor total dos créditos
                  solicitados, bem como os dados bancários da nossa empresa para
                  a realização de uma transferência.
                </v-accordion>
                <v-accordion
                  id="faq-wallet-5"
                  group="faq-accordion-wallet"
                  title="Como faço para pagar uma compra de créditos?"
                >
                  Atualmente estamos operando apenas com transferências
                  bancárias como TED e DOC, mas em breve, iremos disponibilizar
                  também o pagamento por boletos. Voc6e receberá por email os
                  dados bancários da nossa empresa para efetuar a transferência.
                  Após confirmarmos o seu pagamento, os créditos são liberados
                  na Plataforma.
                </v-accordion>
                <v-accordion
                  id="faq-wallet-6"
                  group="faq-accordion-wallet"
                  title="O que é o Extrato da minha Carteira?"
                >
                  É o histórico de todas as operações financeiras que voc6e
                  efetuou a cada mês na Plataforma Vibbra. Isso envolve desde
                  operações de compra de créditos até aprovações de pagamentos
                  para cada Profissional contratado.
                </v-accordion>
              </div>
            </v-content>
            <v-content
              class="tab-pane fade"
              id="tab-profile-client"
              role="tabpanel"
            >
              <div id="faq-accordion-profile-client">
                <v-accordion
                  id="faq-profile-client-1"
                  group="faq-accordion-profile-client"
                  title="Como faço para editar as informações do meu Perfil?"
                >
                  Basta clicar no link "Editar", que fica abaixo de todas as
                  informações presentes na coluna do lado esquerdo da tela.
                </v-accordion>
                <v-accordion
                  id="faq-profile-client-2"
                  group="faq-accordion-profile-client"
                  title="Edição do perfil: o que são as informações da aba Perfil?"
                >
                  Nessa aba você coloca suas informações de contato e seu
                  LinkedIn, bem como sinaliza se deseja assinar os contratos na
                  Plataforma Vibbra como pessoa jurídica (PJ) ou pessoa física
                  (PF).
                </v-accordion>
                <v-accordion
                  id="faq-profile-client-3"
                  group="faq-accordion-profile-client"
                  title="Edição do perfil: o que são as informações da aba Conta?"
                >
                  Referem-se às informações de acesso a sua conta na Plataforma
                  Vibbra.
                </v-accordion>
                <v-accordion
                  id="faq-profile-client-4"
                  group="faq-accordion-profile-client"
                  title="Edição do perfil: o que são as informações da aba Contrato PF?"
                >
                  Caso você tenha sinalizado que deseja assinar contratos como
                  pessoa física (PF) na aba Perfil, precisa preencher todas as
                  informações dessa aba para que consiga assinar os contratos.
                </v-accordion>
                <v-accordion
                  id="faq-profile-client-5"
                  group="faq-accordion-profile-client"
                  title="O que é a Empresa para contratos?"
                >
                  Refere-se a empresa a qual você representa e pela qual irá
                  assinar os contratos na Plataforma Vibbra, caso tenha
                  sinalizado que deseja assinar contratos como pessoa jurídica
                  (PJ) na aba Perfil.
                </v-accordion>
                <v-accordion
                  id="faq-profile-client-6"
                  group="faq-accordion-profile-client"
                  title="Como edito as informações da minha empresa pela qual irei assinar os contratos?"
                >
                  Basta clicar no link "Editar", que fica no lado direito da
                  tela, na coluna direita onde fica o texto "Empresa para
                  contratos".
                </v-accordion>
              </div>
            </v-content>
            <v-content
              class="tab-pane fade"
              id="tab-professionals"
              role="tabpanel"
            >
              <div id="faq-accordion-professionals">
                <v-accordion
                  id="faq-professionals-1"
                  group="faq-accordion-professionals"
                  title="O que é a aba Ativos?"
                >
                  Local onde ficam listados todos os Profissionais para os quais
                  você possui um contrato Ativo.
                </v-accordion>
                <v-accordion
                  id="faq-professionals-2"
                  group="faq-accordion-professionals"
                  title="Aba Ativos: O que significa a informação de horas trabalhadas que aparece no canto superior direito da card de cada profissional?"
                >
                  Quantidade de horas já trabalhadas e reportadas pelo
                  Profissional em questão.
                </v-accordion>
                <v-accordion
                  id="faq-professionals-3"
                  group="faq-accordion-professionals"
                  title="Aba Ativos: O que significam as Últimas tarefas na card de cada profissional?"
                >
                  São as últimas 2 ou 3 atividades reportadas pelo Profissional.
                </v-accordion>
                <v-accordion
                  id="faq-professionals-4"
                  group="faq-accordion-professionals"
                  title="O que é a aba Em contratação?"
                >
                  Local onde ficam listados todos os Profissionais com os quais
                  você está em conversação para efetuar uma possível
                  contratação.
                </v-accordion>
                <v-accordion
                  id="faq-professionals-5"
                  group="faq-accordion-professionals"
                  title="Aba Em contratação: O que significam as tags de diferentes cores que aparecem acima da Quantidade de horas desejadas na card de cada profissional?"
                >
                  Referem-se aos diferentes status do processo de contratação
                  para cada Profissional.
                </v-accordion>
                <v-accordion
                  id="faq-professionals-6"
                  group="faq-accordion-professionals"
                  title="Aba Em contratação: O que significa o status Aguardando assinatura do profissional?"
                >
                  Esse é o primeiro estágio do processo de contratação. Logo
                  após você requisitar o Profissional, o pedido fica aguardando
                  uma posição do Profissional em relação a sua demanda. Ele pode
                  recusar caso não tenha interesse, ou então assinar o contrato,
                  demonstrando que está tudo ok da parte dele para seguir com a
                  contratação.
                </v-accordion>
                <v-accordion
                  id="faq-professionals-7"
                  group="faq-accordion-professionals"
                  title="Aba Em contratação: O que significa o status Aguardando assinatura do contratante?"
                >
                  Essa é o segundo estágio do processo de contratação. Logo após
                  o Profissional assinar o contrato, agora é hora de você como
                  contratante assinar também.
                </v-accordion>
                <v-accordion
                  id="faq-professionals-8"
                  group="faq-accordion-professionals"
                  title="Aba Em contratação: O que significa o status Aguardando compra de créditos?"
                >
                  Essa é o terceiro estágio do processo de contratação. Logo
                  após você como Contratante assinar o contrato, é hora de
                  comprar créditos para o Profissional, ativando assim o
                  contrato e podendo dar início aos trabalhos.
                </v-accordion>
                <v-accordion
                  id="faq-professionals-9"
                  group="faq-accordion-professionals"
                  title="Aba Em contratação: O que significa o status Profissional indisponível?"
                >
                  Esse status aparece quando houve uma recusa do pedido pelo
                  Profissional, ou um cancelamento após já ter assinado o
                  contrato, sinalizando uma desistência. Sempre que isso ocorre,
                  o Profissional informa o motivo da indisponibilidade para que
                  o Contratante fique a par.
                </v-accordion>
                <v-accordion
                  id="faq-professionals-10"
                  group="faq-accordion-professionals"
                  title="Aba Em contratação: O que significa o status Em revisão pela Vibbra?"
                >
                  Esse status aparece quando há o envolvimento da equipe da
                  Vibbra para moderar alguma mensagem ou verificar alguma
                  informação antes de liberar um novo status ao pedido. Nossa
                  equipe comercial está sempre acompanhando todos os pedidos
                  abertos na Plataforma e busca ajudar sempre que julgar
                  pertinente.
                </v-accordion>
                <v-accordion
                  id="faq-professionals-11"
                  group="faq-accordion-professionals"
                  title="Aba Em contratação: O que significa o item Quantidade de horas desejadas na card de cada profissional?"
                >
                  Refere-se a quantidade de horas informada por você na tela de
                  Requisição dos Profissionais.
                </v-accordion>
                <v-accordion
                  id="faq-professionals-12"
                  group="faq-accordion-professionals"
                  title="Aba Em contratação: O que significa o item Experiência na card de cada profissional?"
                >
                  Refere-se a informação de anos de experiência do Profissional,
                  presente em seu perfil na Plataforma.
                </v-accordion>
                <v-accordion
                  id="faq-professionals-13"
                  group="faq-accordion-professionals"
                  title="Aba Em contratação: O que significa o item Valor/hora na card de cada profissional?"
                >
                  Refere-se ao valor da hora do Profissional que será aplicado a
                  esse contrato se efetivado. Em casos específicos, pode haver
                  uma aplicação de valor hora diferente da apresentada no perfil
                  do Profissional. Quando isso ocorre, fica informado neste item
                  o valor original e o valor novo aplicado.
                </v-accordion>
                <v-accordion
                  id="faq-professionals-14"
                  group="faq-accordion-professionals"
                  title="Aba Em contratação: O que significa o item Horas semanais na card de cada profissional?"
                >
                  Refere-se a quantidade de horas semanais que o Profissional
                  poderá dedicar durante o contrato em questão. Em casos
                  específicos, pode haver uma definição de horas semanais
                  diferente da apresentada no perfil do Profissional. Quando
                  isso ocorre, fica informado neste item a quantidade original e
                  a quantidade nova aplicada.
                </v-accordion>
                <v-accordion
                  id="faq-professionals-15"
                  group="faq-accordion-professionals"
                  title="Aba Em contratação: O que significa o texto abaixo de Horas semanais na card de cada profissional?"
                >
                  Refere-se a descrição da demanda informada por você na tela de
                  Requisição dos Profissionais. Caso nenhum descrição tenha sido
                  informada, aparece a mensagem "Nenhuma descrição informada".
                </v-accordion>
                <v-accordion
                  id="faq-professionals-16"
                  group="faq-accordion-professionals"
                  title="Aba Em contratação: O que faz o botão Mensagens na card de cada profissional?"
                >
                  Esse é o local onde você pode trocar mensagens diretamente com
                  o Profissional em questão. Ao clicar, abre um popup com campo
                  de texto para escrita e envio da mensagem, bem como a lista do
                  histórico de mensagens trocadas. Sempre que uma nova mensagem
                  é recebida, é sinalizado nesse botão com um ícone vermelho de
                  envelope, que há uma nova mensagem não lida. Após a leitura,
                  esse ícone some. Todas as mensagens enviadas aqui são
                  moderadas pela equipe da Vibbra.
                </v-accordion>
                <v-accordion
                  id="faq-professionals-17"
                  group="faq-accordion-professionals"
                  title="Aba Em contratação: Porque a mensagem que acabei de enviar não é logo mostrada quando fecho e abro novamente o popup de mensagens?"
                >
                  Isso ocorre pois todas as mensagens trocadas pela Plataforma
                  são moderadas por nossa equipe, ou seja, há uma verificação
                  humana das mesmas. Então, logo que você envia uma mensagem,
                  nossa equipe revisa e então libera para ser entregue. Nossa
                  equipe busca sempre ser o mais ágil possível para essa
                  liberação. Ocorrem moderações ou veto de mensagens quando
                  apresentam informações de contatos externos a nossa plataforma
                  ou outros comportamentos que desrespeitam nossos
                  <v-link :to="{ name: 'terms' }" target="_blank"
                    ><b>Termos de Uso</b></v-link
                  >.
                </v-accordion>
                <v-accordion
                  id="faq-professionals-18"
                  group="faq-accordion-professionals"
                  title="Aba Em contratação: O que faz o botão Cancelar na card de cada profissional?"
                >
                  Assim como o Profissional pode recusar ou cancelar um pedido
                  de contratação, você como Contratante também pode cancelar um
                  pedido aberto para um Profissional. Sempre que cancelar,
                  precisa informar o motivo para que o Profissional seja
                  informado. Antes de cancelar um pedido, você pode sempre
                  buscar ajuda da nossa equipe para vermos se conseguimos
                  ajudá-lo.
                </v-accordion>
                <v-accordion
                  id="faq-professionals-19"
                  group="faq-accordion-professionals"
                  title="Aba Em contratação: O são os botões azuis no pé de cada card de cada profissional?"
                >
                  Refere-se aos botões de ações referentes a cada estágio do
                  processo de contratação. Eles podem ser: Assinar contrato,
                  Buscar parecidos, Comprar créditos. No caso de Buscar
                  parecidos, refere-se ao caso do Profissional estar
                  indisponível, você pode então clicar nesse botão que a
                  Plataforma irá apresentar na tela de Busca, outros
                  Profissionais com o mesmo perfil deste que não pode atendê-lo.
                </v-accordion>
                <v-accordion
                  id="faq-professionals-20"
                  group="faq-accordion-professionals"
                  title="O que é a aba Finalizados?"
                >
                  Local onde ficam listados todos os Profissionais que você já
                  contratou uma vez e tiveram seus contratos finalizados.
                </v-accordion>
                <v-accordion
                  id="faq-professionals-21"
                  group="faq-accordion-professionals"
                  title="Aba Finalizados: O que significa a informação de horas trabalhadas que aparece no canto superior direito da card de cada profissional?"
                >
                  Quantidade de horas totais trabalhadas e reportadas pelo
                  Profissional em questão neste contrato.
                </v-accordion>
                <v-accordion
                  id="faq-professionals-22"
                  group="faq-accordion-professionals"
                  title="Aba Finalizados: O que faz o botão Avaliar?"
                >
                  Quando um contrato de um Profissional é finalizado, você pode
                  avaliá-lo quanto a sua qualidade técnica, profissionalismo e
                  se o contrataria novamente. Essa avaliação é muito importante
                  para a Vibbra e para os Profissionais, então, não deixe de dar
                  sempre o seu feedback. Ao clicar, abre um popup com as opções
                  de avaliação.
                </v-accordion>
                <v-accordion
                  id="faq-professionals-23"
                  group="faq-accordion-professionals"
                  title="Aba Finalizados: O que faz o botão Ver histórico?"
                >
                  Ao clicar, abre a tela de Acompanhamento desse Profissional,
                  para que possa consultar todo o histórico de atividades
                  executadas enquanto o contrato estava ativo. Nessa tela você
                  também consegue reativar o contrato do Profissional. Para
                  isso, basta fazer a contratação de novas horas a partir dessa
                  tela de histórico. Assim que contratar, o contrato passará
                  novamente para a aba Ativos.
                </v-accordion>
              </div>
            </v-content>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-page>
</template>

<script>
export default {};
</script>

<style lang="scss">
.terms-text {
  font-size: 0.9em;
  h1 {
    font-size: 1.8em;
  }
  h2 {
    font-size: 1.6em;
  }
}
$height: 62px;
.navbar.topbar {
  height: $height;
  padding: 0;
  background-color: color('primary');
  .container {
    position: relative;
  }
  .logo {
    height: 44px;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/pages/faq.vue